// #region Dependencias
import { Form, Input, InputTextArea } from 'components/Library'
// #endregion

/**
 * Componente que maneja la edición de datos principales de las landing pages.
 * @class
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.idioma - Idioma actual de la aplicación.
 * @param {Object} props.formValues - Objeto con los valores de los campos del formulario de la página.
 * @param {Function} props.handleInputChange - Callback para actualizar los valores de un elemento de la página.
 */
const MenuDatos = ({ idioma, formValues, handleInputChange }) => {
  return (
    <Form
      style={{
        padding: '1rem'
      }}
    >
      <Input
        name="url"
        label="Enlace"
        helper="Enlace de la página"
        placeholder="guanaban-app"
        value={formValues.url}
        onChange={handleInputChange}
      />
      <Input
        name={`opciones.${idioma}.titulo`}
        label="Título de página"
        helper="Título de la página"
        placeholder="GuanabanApp"
        value={formValues.opciones[idioma].titulo}
        onChange={handleInputChange}
      />
      <InputTextArea
        name={`opciones.${idioma}.descripcion`}
        label="Descripción de página"
        helper="Descripción de la página"
        value={formValues.opciones[idioma].descripcion}
        onChange={handleInputChange}
      />
      <InputTextArea
        name={`opciones.${idioma}.keywords`}
        label="Palabras clave"
        helper="Palabras clave de la página separadas por comas"
        value={formValues.opciones[idioma].keywords}
        onChange={handleInputChange}
      />
    </Form>
  )
}

export default MenuDatos
